import { call, put, take, takeEvery, takeLatest, select } from 'redux-saga/effects'
import { browserHistory } from 'react-router'
import createDomChannel from './channel-dom';
import createUserAuthChannel from './channel-auth';
import firebase from 'firebase';
import { history } from '../index';
import {
    NAV, APP_STARTUP_NAV, APP_STARTUP, USER_UPDATE, SHOW_NAV, NAV_BACK, APP_STARTUP_DOM, MODAL_HIDE, MODAL_USER_PROMPT_LOGIN, APP_STARTUP_COMPLETE, MODAL_ORACLE_COLLECT_EMAILS, USER_FETCH_BETS, USER_FETCH_STATS
} from '../constants/action-types';
import config from '../config';

function* appStartup(action) {

    firebase.initializeApp(config.firebaseConfig)

    yield put({type:APP_STARTUP_DOM})

    try {
        const user = yield call(() => new Promise((r, re) => firebase.auth().onAuthStateChanged((u) => r(u))))

        if (user) {

            // get stats. 

            yield put({type: USER_FETCH_STATS})
            yield put({type: USER_FETCH_BETS })
            yield put({type: USER_UPDATE, payload: firebase.auth().currentUser})

        }
        
        yield put({type: APP_STARTUP_COMPLETE})

    } catch (e) {

        yield put({ type: "USER_FETCH_FAILED", message: e.message });

    }
}

function* appStartupDom() {

    const state = yield select(state => state)

    //——————————————————————————————————
    //
    // Ev listeners
    //
    //——————————————————————————————————
    yield put({type: SHOW_NAV, payload: window.outerWidth >= 768 ? true : false})

    const domEventChannel = yield call(createDomChannel)

    while (true) {

        const domPayload = yield take(domEventChannel)

        if (domPayload.type === 'resize')

            yield put({type: SHOW_NAV, payload: window.outerWidth >= 768 ? true : false})

        if (domPayload.type === 'click')

            if (!document.querySelector('nav').contains(domPayload.ev.target) && 
                !document.querySelector('#content-mobile-nav-menu-trigger').contains(domPayload.ev.target) &&
                window.outerWidth <= 768 &&
                state.nav.showNav)
                
                yield put({type: SHOW_NAV, payload: false})

    }

}
 
function* getUserBalances() {

    // const accountContractId = web3.eth.accounts[0]
    // try {

    //     const userMetaMaskResults = yield call(() => Promise.all([
    //         new Promise((resolve, reject) =>
    //             safeMevuContractInstance.balanceOf(accountContractId).then(balance =>
    //                 resolve({ mvuBalance: balance.toNumber() })
    //             )),
    //         new Promise((resolve, reject) =>
    //             web3.eth.getBalance(accountContractId,
    //                 (err, balance) => {
    //                     if (err) reject(err);
    //                     resolve({ ethBalance: precisionRound((balance / 1000000000000000000), 4) })
    //                 })),
    //         new Promise((resolve, reject) =>
    //             rewardsContractInstance.getUnlockedMvuBalance(accountContractId).then(balance => {
    //                 resolve({ contractMvuBalance: (balance.toNumber()) })
    //             }).catch(e => reject(e))),
    //         new Promise((resolve, reject) =>
    //             rewardsContractInstance.getUnlockedEthBalance(accountContractId).then(balance => {
    //                 resolve({ contractEthBalance: precisionRound((balance.toNumber() / 1000000000000000000), 4) })
    //             }).catch(e => reject(e)))
    //     ]))
        
    //     const balances = userMetaMaskResults.reduce((o, obj) => ({ ...o, [Object.keys(obj)[0]]: obj[Object.keys(obj)[0]] }), {})
    
    //     yield put({ type: USER_UPDATE_BALANCES, payload: balances })
        
    // } catch(e) {

    //     yield put({ type: USER_UPDATE_BALANCES_ERROR, payload: e.message })
        
    // }
    // yield put({ type: USER_UPDATE })

}

function* appStartupNetwork() {

    // if (!window.web3) {

    //     yield put({ type: MODAL_SHOW, modal: MODAL_METAMASK_NOT_INSTALLED, closable: false })
    //     return false

    // }

    // if (!web3.eth.accounts || !web3.eth.accounts[0]) {

    //     yield put({ type: MODAL_SHOW, closable: false, modal: MODAL_METAMASK_NOT_CONFIGURED })
    //     return false;

    // }

    // switch (web3.version.network) {

    //     case "4":
    //         break

    //     case "1":
    //     default:
    //         yield put({ type: MODAL_SHOW, closable: false, modal: MODAL_INCORRECT_NETWORK })
    //         return false

    // }

    return true

}

function* onModalHide() {

    const state = yield select(state => state)
    if (state.modal.modal === MODAL_USER_PROMPT_LOGIN ||
        state.modal.modal === MODAL_ORACLE_COLLECT_EMAILS)

        yield put({type: NAV, pathname: '/events'})

}

function* navBack() {

    history.back();

}

// trigger router navigation via history
// Also trigger async actions here.
function* watchNavigate() {

    while (true) {

        const { pathname } = yield take(NAV)
        browserHistory.push(pathname)

    }

}

export default [
    takeLatest(NAV_BACK, navBack),
    takeLatest(MODAL_HIDE, onModalHide),
    takeLatest(APP_STARTUP, appStartup),
    takeLatest(APP_STARTUP_DOM, appStartupDom),
    takeLatest(APP_STARTUP_NAV, watchNavigate)
]


// WEBPACK FOOTER //
// ./src/sagas/app.js